import React from 'react';

const Google: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2139_6768)">
        <path d="M8 6.5459V9.64409H12.3054C12.1164 10.6404 11.549 11.4841 10.6981 12.0514L13.2945 14.0659C14.8072 12.6696 15.68 10.6187 15.68 8.18234C15.68 7.61508 15.6291 7.06957 15.5345 6.54599L8 6.5459Z" fill="#4285F4"/>
        <path d="M3.51771 9.52246L2.93214 9.97071L0.859375 11.5852C2.17574 14.1961 4.87372 15.9998 8.00096 15.9998C10.1609 15.9998 11.9718 15.287 13.2955 14.0653L10.6991 12.0507C9.98638 12.5307 9.07728 12.8216 8.00096 12.8216C5.92098 12.8216 4.15376 11.418 3.52098 9.52708L3.51771 9.52246Z" fill="#34A853"/>
        <path d="M0.858119 4.41406C0.312695 5.49038 0 6.70494 0 7.99947C0 9.29399 0.312695 10.5086 0.858119 11.5849C0.858119 11.5921 3.51998 9.51942 3.51998 9.51942C3.35998 9.03942 3.26541 8.53036 3.26541 7.99939C3.26541 7.46841 3.35998 6.95935 3.51998 6.47935L0.858119 4.41406Z" fill="#FBBC05"/>
        <path d="M8.00113 3.18545C9.17933 3.18545 10.2266 3.59271 11.0629 4.37818L13.3538 2.0873C11.9647 0.792777 10.1612 0 8.00113 0C4.87388 0 2.17574 1.79636 0.859375 4.41455L3.52116 6.48001C4.15385 4.58908 5.92114 3.18545 8.00113 3.18545Z" fill="#EA4335"/>
      </g>
      <defs>
        <clipPath id="clip0_2139_6768">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Google;
